import clone from 'lodash/clone'
import setWith from 'lodash/setWith'

export function setIn(initial, path, value) {
  return setWith(clone(initial), path, value, clone)
}
